import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { TodayOutlined as TodayIcon } from '@mui/icons-material';
export interface PlanHeaderProps {
  title: string;
  subtitle: string;
}

export const PlanHeader: React.FC<PlanHeaderProps> = ({ title, subtitle }) => {
  return (
    <Paper
      elevation={1}
      sx={{
        p: 3,
        mb: 3,
        backgroundColor: '#002A76',
        color: 'white',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <TodayIcon sx={{ fontSize: 40, mr: 2 }} />
        <Box>
          <Typography
            variant='h3'
            fontWeight='bold'
            sx={{
              fontSize: { xs: '1.75rem', sm: '2rem', md: '2.5rem' },
            }}
          >
            {title}
          </Typography>
          <Typography
            variant='h6'
            sx={{
              opacity: 0.9,
              mt: 1,
              fontSize: { xs: '1rem', sm: '1.125rem', md: '1.25rem' },
            }}
          >
            {subtitle}
          </Typography>
        </Box>
      </Box>
    </Paper>
  );
};
